export const createAdminUser = async (userToken, UseradminData) => {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);

    const requestBody = {
      name: UseradminData.fullname,
      email: UseradminData.email,
      password: UseradminData.confirmPassword,
      role: UseradminData.userType,
      phone: UseradminData.phone,
      user_name: UseradminData.username,
    };
    if (UseradminData.page_access != null && Array.isArray(UseradminData.page_access)) {
      requestBody.page_access = UseradminData.page_access;
    }
    if ((UseradminData.userType === "admin" || UseradminData.userType === "user") && UseradminData.balanceSheetPassword) {
      requestBody.balance_sheet_password = UseradminData.balanceSheetPassword;
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(requestBody),
      redirect: "follow",
    };

    const response = await fetch(
      `${window.constants.api_url}/add-user`,
      requestOptions
    );
    const result = await response.json(); // Parse response as JSON
    return result;
  } catch (error) {
    throw new Error("Failed to create package: " + error.message);
  }
};

export const retrieveAdminUser = async (
  token,
  userId,
  searchText,
  limit,
  index,
  navigate // pass navigate from useNavigate()
) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    search_text: searchText,
    limit: limit,
    index: index,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/retrive-user`,
      requestOptions
    );

    if (response.status === 401) {
      navigate("/");
      return;
    }

    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve user: " + error.message);
  }
};

export const AutocompleteAdminUser = async (token, userId, searchText) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    search_text: searchText,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/auto-complete-user`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};
export const DeleteAdminUser = async (token, userId, id) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    id: id,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/delete-user`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};

export const StatusAdminUser = async (token, userId, status, id) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    id: id,
    status: status,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.constants.api_url}/user-status`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to retrieve package: " + error.message);
  }
};
export const UpdateAdminUser = async (
  id,
  userToken,
  editedData,
  confirmPassword
) => {
  console.log("editable", editedData);
  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);

    const requestBody = {
      id: id,
      name: editedData.fullname,
      email: editedData.email,
      password: confirmPassword,
      role: editedData.role,
      phone: editedData.phone,
      user_name: editedData.user_name,
    };
    if (editedData.page_access != null && Array.isArray(editedData.page_access)) {
      requestBody.page_access = editedData.page_access;
    }
    if ((editedData.role === "admin" || editedData.role === "user") && editedData.balanceSheetPassword) {
      requestBody.balance_sheet_password = editedData.balanceSheetPassword;
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(requestBody),
      redirect: "follow",
    };

    const response = await fetch(
      `${window.constants.api_url}/update-user`,
      requestOptions
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw new Error("Failed to update user: " + error.message);
  }
};

/**
 * List device command logs (biometric device add/update/delete-user pushes).
 * POST /api/device-command-logs
 * Body: { status?, action?, search?, date_from?, date_to?, limit?, index? }
 * Returns: { data: [...], total_count, code }
 */
export const getDeviceCommandLogs = async (token, body = {}) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: "follow",
  };

  const response = await fetch(
    `${window.constants.api_url}/device-command-logs`,
    requestOptions
  );
  const result = await response.json();
  return result;
};

/**
 * POST /api/device/unlock-door
 * Body: { sn? }
 * Queues an AC_UNLOCK command for the bridge to send to the biometric device,
 * opening the door relay for a few seconds.
 * Returns: { success, message }
 */
export const unlockDoor = async (token, sn) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({ sn }),
    redirect: "follow",
  };

  const response = await fetch(
    `${window.constants.api_url}/device/unlock-door`,
    requestOptions
  );
  const result = await response.json();
  return result;
};

/**
 * Verify the logged-in admin's balance sheet page password.
 * POST /api/verify-balance-password
 * Body: { id, password }
 * Returns: { message, code }
 */
export const verifyBalanceSheetPassword = async (token, id, password) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({ id, password }),
    redirect: "follow",
  };

  const response = await fetch(
    `${window.constants.api_url}/verify-balance-password`,
    requestOptions
  );
  const result = await response.json();
  return result;
};

/**
 * List all operation logs with optional filters.
 * POST /api/operation-logs
 * Body: { user_id?, date_from?, date_to?, search?, limit?, index? }
 * Returns: { data: [...], total_count, code }
 */
export const getOperationLogs = async (token, body = {}) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: "follow",
  };

  const response = await fetch(
    `${window.constants.api_url}/operation-logs`,
    requestOptions
  );
  const result = await response.json();
  return result;
};

/**
 * Get users who have operation logs (for filter dropdown).
 * POST /api/operation-logs/users
 * Returns: { data: [{ id, name, email, user_name, role }], code }
 */
export const getOperationLogsUsersForFilter = async (token) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({}),
    redirect: "follow",
  };

  const response = await fetch(
    `${window.constants.api_url}/operation-logs/users`,
    requestOptions
  );
  const result = await response.json();
  return result;
};

/**
 * Delete operation logs older than 1 month.
 * POST /api/operation-logs/delete-old
 * Returns: { message, deleted_count, code }
 */
export const deleteOldOperationLogs = async (token) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({}),
    redirect: "follow",
  };

  const response = await fetch(
    `${window.constants.api_url}/operation-logs/delete-old`,
    requestOptions
  );
  const result = await response.json();
  return result;
};

/**
 * POST /api/device/enroll
 * Body: { person_type: "employee"|"nonregister"|"member", person_id, mode: "finger"|"face", fid? }
 * Queues add-user + enrol commands for the machine.
 * Returns: { message, data: { pin, user_cmd_id, enroll_cmd_id }, code }
 */
export const startDeviceEnroll = async (token, body) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const response = await fetch(`${window.constants.api_url}/device/enroll`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: "follow",
  });
  return await response.json();
};

/**
 * POST /api/device/read-card
 * Body: { person_type, person_id }
 * Asks the machine for this person's card (enrolled on the machine's own menu) and saves the number.
 * Returns: { message, data: { pin, query_cmd_id }, code }
 */
export const readCardFromMachine = async (token, body) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const response = await fetch(`${window.constants.api_url}/device/read-card`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: "follow",
  });
  return await response.json();
};

/**
 * POST /api/device/biometric-delete
 * Body: { person_type, person_id, target: "finger"|"all_fingers", fid? }
 * Removes a fingerprint or face template from the machine (the user stays).
 * Returns: { message, data: { pin, cmd_id }, code }
 */
export const deleteDeviceBiometric = async (token, body) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const response = await fetch(`${window.constants.api_url}/device/biometric-delete`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: "follow",
  });
  return await response.json();
};

const postJson = async (token, path, body) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);
  const response = await fetch(`${window.constants.api_url}${path}`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: "follow",
  });
  return await response.json();
};

/**
 * POST /api/device/biometrics
 * Body: { person_type, person_id }
 * Returns: { data: { pin, fingers: [fid...], face: bool }, code }
 */
export const getDeviceBiometrics = (token, body) => postJson(token, "/device/biometrics", body);

/**
 * POST /api/device/cancel
 * Body: { cmd_ids: [] } — withdraws enrol/delete commands that have not finished.
 */
export const cancelDeviceCommands = (token, cmdIds) =>
  postJson(token, "/device/cancel", { cmd_ids: cmdIds });

/**
 * POST /api/device/card
 * Body: { person_type, person_id, card_number }  (empty card_number removes the card)
 * Saves the card number on the person and sends it to the machine.
 * Returns: { message, data: { pin, cmd_id, card }, code }
 */
export const saveDeviceCard = (token, body) => postJson(token, "/device/card", body);
